import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
      caches: ["localStorage", "cookie"],
      // Custom function to normalize the detected language code
      lookupLocalStorage: "i18nextLng",
      checkWhitelist: true,
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      lookupQuerystring: "lng",
      lookupCookie: "i18next",
      lookupSessionStorage: "i18nextLng",
      lookupNavigator: "language",
      // Normalize the language code format
      lookup: function () {
        let detectedLanguage = this.detect();
        return detectedLanguage
          ? detectedLanguage.replace("_", "")
          : detectedLanguage;
      },
    },
    debug: true,
    fallbackLng: "enUS",
  });

export default i18n;
